export default __webpack_public_path__ + "locales/fi/PeopleTranslations.json?hash=f2b7dafa765bec1611c3530a46ee822d";